import { Component } from "react";
import PropTypes from "prop-types";
import ErrorMessage from "../../components/ErrorMessage";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div>
          <ErrorMessage />
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
  formatLink: PropTypes.func,
  formatTranslation: PropTypes.func
};

export default ErrorBoundary;
